import { render, staticRenderFns } from "./TencentCharityTips.vue?vue&type=template&id=66ea2342&scoped=true&"
import script from "./TencentCharityTips.vue?vue&type=script&lang=ts&"
export * from "./TencentCharityTips.vue?vue&type=script&lang=ts&"
import style0 from "./TencentCharityTips.vue?vue&type=style&index=0&id=66ea2342&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea2342",
  null
  
)

export default component.exports